import React from "react";
import { Box, Stepper, Step, StepLabel } from "@mui/material";

interface StepData {
  label: string;
  content: React.ReactNode;
}

interface CustomStepperProps {
  steps: StepData[];
  activeStep: number;
  onStepChange: (step: number) => void;
  isNonLinear?: boolean;
}

const CustomStepper: React.FC<CustomStepperProps> = ({
  steps,
  activeStep,
  onStepChange,
  isNonLinear = false,
}) => {
  const handleStepClick = (stepIndex: number) => {
    if (isNonLinear) {
      onStepChange(stepIndex); // Allow navigation only if non-linear mode is enabled
    }
  };

  return (
    <Box>
      <Stepper
        nonLinear={isNonLinear}
        activeStep={activeStep}
        alternativeLabel
        sx={{
          "& .MuiStepLabel-root .Mui-active": {
            color: "#353c52", // Change the color of the active step
          },
          "& .MuiStepLabel-root .Mui-completed": {
            color: "#353c52", // Change the color of completed steps
          },
        }}
      >
        {steps.map((step, index) => (
          <Step key={index} onClick={() => handleStepClick(index)}>
            <StepLabel>{step.label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      <Box marginTop={2}>
        {steps[activeStep] && <Box>{steps[activeStep].content}</Box>}
      </Box>
    </Box>
  );
};

export default CustomStepper;
